export const UTDATE_OTP_AUTH="UTDATE_OTP_AUTH"

export const  UPDATE_OTP="UPDATE_OTP"
